var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { attrs: { id: "swiperContent" } },
    _vm._l(_vm.resourceData, function(data, index) {
      return _c(
        "li",
        {
          key: data.id,
          staticClass: "swiper_list",
          class: { swiper_active: data.id == _vm.resourceId }
        },
        [
          _c("img", {
            class: { actives: data.id == _vm.resourceId },
            attrs: { src: _vm.img, alt: "" },
            on: {
              click: function($event) {
                return _vm.sendMsg(data)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "swiper_items",
              on: {
                click: function($event) {
                  return _vm.sendMsg(data)
                }
              }
            },
            [
              data.type == 1
                ? _c("img", { attrs: { src: _vm.picture, alt: "" } })
                : _vm._e(),
              _vm._v(" "),
              data.type == 2
                ? _c("img", { attrs: { src: _vm.doc, alt: "" } })
                : _vm._e(),
              _vm._v(" "),
              data.type == 3
                ? _c("img", { attrs: { src: _vm.audio, alt: "" } })
                : _vm._e(),
              _vm._v(" "),
              data.type == 4
                ? _c("img", { attrs: { src: _vm.video, alt: "" } })
                : _vm._e(),
              _vm._v(" "),
              data.type == 5
                ? _c("img", { attrs: { src: _vm.doc, alt: "" } })
                : _vm._e(),
              _vm._v(" "),
              data.resourceType == 3
                ? _c("img", { attrs: { src: _vm.doc, alt: "" } })
                : _vm._e(),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    data.resourceType == 3 ? "任务" + (index + 1) : data.name
                  )
                )
              ])
            ]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-484b00ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-484b00ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subcomponent/courseList/index.vue
// module id = null
// module chunks = 